import Home from '../../containers/Mobile/Home'
import Pesticides from '../../containers/Mobile/Pesticides'
import Cart from '../../containers/Mobile/Cart'
import Order from '../../containers/Mobile/Order'
import UnderMaintenance from '../../components/Mobile/UnderMaintenance'
import PesticideByCategory from '../../containers/Mobile/PesticideByCategory'
import { ROUTE } from '../../utils/User/constants/routingConfig/routeDetails'
import PesticideBy from '../../containers/Mobile/PesticideBy'
import PesticidePreview from '../../containers/Mobile/PesticidePreview'

const publicRoute = [
  {
    path: ROUTE.HOME,
    component: Home,
  },

  // Pesticide
  {
    path: ROUTE.PESTICIDES,
    component: Pesticides,
  },
  {
    path: ROUTE.PESTICIDESBYCATEGORY,
    component: PesticideByCategory,
  },
  {
    path: ROUTE.PESTICIDESBYID,
    component: PesticideBy,
  },
  {
    path: ROUTE.PESTICIDEPREVIEWBYID,
    component: PesticidePreview,
  },

  // Cart
  {
    path: ROUTE.CART,
    component: Cart,
  },
  {
    path: ROUTE.FERTILIZER,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.SEED,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.ANIMAL,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.DAIRY,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.FACILITIES,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.SEMINAR,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.KCC,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.ADVISOR,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.APPLY,
    component: UnderMaintenance,
  },
  {
    path: ROUTE.CONTACTUS,
    component: UnderMaintenance,
  },
]

const privateRoute = [
  {
    path: ROUTE.ORDER,
    component: Order,
  },
  {
    path: ROUTE.ACCOUNT,
    component: UnderMaintenance,
  },
]

export { publicRoute, privateRoute }
